import { UmbCardCollectionViewElement } from './card-collection-view.element.js';
import type { UmbExtensionManifestKind } from '@umbraco-cms/backoffice/extension-registry';

export const manifests: Array<UmbExtensionManifest | UmbExtensionManifestKind> = [
	{
		type: 'kind',
		alias: 'Umb.Kind.CollectionView.Card',
		matchKind: 'card',
		matchType: 'collectionView',
		manifest: {
			type: 'collectionView',
			kind: 'card',
			element: UmbCardCollectionViewElement,
			weight: 800,
			meta: {
				label: '#collection_cardViewLabel',
				icon: 'icon-grid',
				pathName: 'cards',
			},
		},
	},
];
